<template>
  <!-- FOOTER -->
  <Container
    tag="footer"
    class="z-0 flex flex-col items-start justify-between gap-y-14 bg-blue-500 py-12 text-white md:flex-row"
  >
    <!-- LOGO -->
    <ClientOnly>
      <NuxtLink
        :to="topLevelEntry?.url"
        :aria-label="$t('aria_labels.home')"
      >
        <IconLogo class="h-5 sm:h-7" />
      </NuxtLink>
    </ClientOnly>

    <ul class="flex flex-wrap gap-y-4 max-md:w-full md:gap-x-12">
      <li
        v-for="{ page } in globals?.footer.tree"
        :key="page.id"
        class="text-body-xl hover:text-blue-100 max-md:basis-1/2"
      >
        <NuxtLink :to="toMainSiteUrl(page.url)" :target="useIsExternalUrl(page.url) ? '_blank' : '_self'">
          {{ page.title }}
        </NuxtLink>
      </li>
    </ul>
  </Container>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey, null)
const entry = inject(EntryInjectionKey, null)
const { locales, localeProperties } = useI18n()

// Since the collection allows only one level deep, use parent if it exists, otherwise use entry
const topLevelEntry = computed(() => entry?.value?.parent || entry?.value)

// The footer nav points to legal pages that live on the main gemini.ch site,
// not on the report.gemini.ch subdomain — resolve relative URLs against the
// matching main-site locale so they don't 404 on the report subdomain.
const mainSiteBaseUrl = computed(() => {
  const currentLanguage = localeProperties.value?.language
  const mainLocale = locales.value.find(
    l => !l.isBusinessReport && l.language === currentLanguage,
  ) ?? locales.value.find(l => !l.isBusinessReport)
  const domain = mainLocale?.domain
  if (!domain) return ''
  const protocol = domain.startsWith('localhost') ? 'http' : 'https'
  return `${protocol}://${domain}`
})

function toMainSiteUrl(url: string) {
  if (!url || useIsExternalUrl(url)) return url
  return `${mainSiteBaseUrl.value}${url}`
}
</script>
